import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import { color } from 'styles/colors'

interface ErrorMessageProps {
  id?: string
  errorMessage?: string
  className?: string
  linkUrl?: string
  linkDisplay?: string
}

const ErrorMessage = ({
  id = '',
  errorMessage = '',
  className = '',
  linkUrl = '',
  linkDisplay = ''
}: ErrorMessageProps) => {
  return (
    <>
      {
        errorMessage.length > 0 &&
        <S.ErrorMessage htmlFor={id} {...{ className }}>
          {errorMessage}
          {
            linkUrl && linkDisplay &&
              <NavLink to={linkUrl}>
                {linkDisplay}
              </NavLink>
          }
        </S.ErrorMessage>
      }
    </>
  )
}

export default ErrorMessage

const S = {
  ErrorMessage: styled.label`
    float: right;
    color: ${color('errorMessage')};
    font-size: 13px;
    font-weight: bold;
  `
}
